module.exports = "img/flags/TW.946fea0.png";